module.exports = __webpack_public_path__ + "ca02bad6ce74bfdcd54d1917f1484b31.pdf";